<template>
	<div class="content-wrapper">
		<app-breadcrumb :page-title="'Schedule'" />
		<div class="mb-primary">
			<div class="card p-primary border-0">
				<teacher-pages-schedule-form-wizard :tabs="computedTabs" />
			</div>
		</div>
	</div>
</template>

<script>
const ScheduleClass = () => import("./ScheduleClass.vue");
const ScheduleClassGroup = () => import("./ScheduleClassGroup.vue");

export default {
	name: "Schedule",
	data() {
		return {
			teacherPagesScheduleTabs: [
				{
					icon: "",
					name: "Class",
					component: ScheduleClass,
					permission: true,
					class: ""
				},
				{
					icon: "",
					name: "Class Group",
					component: ScheduleClassGroup,
					permission: true,
					class: ""
				},
			],
		};
	},
	computed: {
		computedTabs() {
			return this.teacherPagesScheduleTabs.map((tab) => {
				if (tab.name === "Class") {
					return {
						...tab,
					};
				}
				if (tab.name === "Class Group") {
					return {
						...tab,
					};
				}
				return tab;
			});
		},
	},
};
</script>

<style scoped>
.content-wrapper {
  margin-bottom: 200px; /* Adjust the margin value as needed */
}
.card {
	box-shadow: 0 10px 12px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
</style>
